import { i18nTranslate } from 'src/utils'
import {
  parsePhoneNumberField,
  validLibMobilePhoneNumber,
} from 'src/utils/signUpUtils'

export const validateDSMobileNumber = async (value, countryCode) => {
  let cleanedMobile = value.replace(/[^0-9]/g, '')
  let error = ''
  if (cleanedMobile.length === 0) return { cleaned: cleanedMobile, error }
  if (cleanedMobile.length < 3 && cleanedMobile.length !== 0) {
    return {
      cleaned: cleanedMobile,
      error: i18nTranslate(
        'validation.phoneError',
        'Please enter a valid mobile number'
      ),
    }
  } else {
    const phoneNumber = await parsePhoneNumberField(cleanedMobile, countryCode)
    const isValidMobile = await validLibMobilePhoneNumber(phoneNumber)
    if (isValidMobile) {
      return {
        cleaned: cleanedMobile,
        error,
      }
    } else {
      error = i18nTranslate(
        'validation.phoneError',
        'Please enter a valid mobile number'
      )
      return { cleaned: cleanedMobile, error }
    }
  }
}

export const validateDSAccountId = value => {
  // Allow only alphanumeric, max 10 chars
  const cleaned = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 10)
  let error = ''
  if (cleaned.length > 0 && cleaned.length !== 10) {
    error = i18nTranslate(
      'dsSearch.dsAccountIdError',
      'Please enter a valid direct seller id'
    )
  }
  return { cleaned, error }
}

export const validateDSFirstOrLastName = (value, field) => {
  // Remove only leading spaces during typing, trailing spaces handled on blur
  const cleaned = value.replace(/^\s+/g, '')
  let error = ''
  if (/[^a-zA-Z\s]/.test(cleaned)) {
    error = i18nTranslate(
      `validation.${field}ErrorMsg`,
      `Please enter a valid ${field === 'firstName' ? 'first name' : 'last name'}`
    )
  } else if (cleaned.length > 35) {
    error = i18nTranslate(
      `validation.${field}ErrorMsg`,
      `Please enter a valid ${field === 'firstName' ? 'first name' : 'last name'}`
    )
  }
  return { cleaned, error }
}
